import { ProductCombinationInterface } from '@qlevr/shared/interfaces';
import { getDefaultVariantOption } from './get-default-variant-option';
import { buildSizeColorUrlParam } from './color-size-variant-options/build-size-color-url-param';

export function getDefaultVariantUrl(path: string, combinations: ProductCombinationInterface[] | null) {
  const values = getDefaultVariantOption(combinations);

  return `${path}/${buildSizeColorUrlParam(values?.size, values?.color)}`;
}
